import * as CampaignActions from './actions'
import { store } from "../../reducers";
import { app } from "../../config/constants";

import * as PromotionsActions from '../promotions/actions'

export const OpenCreateNewCampaignModal = () => {
	store.dispatch( CampaignActions.OpenCreateCampaignModal() )
};

export const CreateCampaign = (campaignData) => {

	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/campaigns').push(campaignData)
			.then((snap) => {
				store.dispatch(PromotionsActions.handleState('campaign', snap.key));
				store.dispatch(CampaignActions.CampaignSaved(campaignData));
				store.dispatch(CampaignActions.CloseCreateCampaignModal());

				resolve();
			});
	});
};

export const closeDialog = () => {
	store.dispatch( CampaignActions.closeDialog() );
};

export const getCampaign = (campaignId ) => {
	return new Promise(( resolve, reject ) => {
		app.database().ref( '/cams/campaigns/' + campaignId ).once('value', ( campaignSnap ) => {
			resolve(campaignSnap);
		})
	});
};


// WEBPACK FOOTER //
// ./src/api/campaigns/index.js